import React, {Component, Fragment} from "react";
import axios from "axios";
import InputComponent from "../../components/InputComponent/InputComponent";
import SelectComponent from "../../components/InputSelectComponent/SelectComponent";
import TextAreaComponent from "../../components/TextAreaComponent/TextAreaComponent";
import ReactDropzone from 'react-dropzone';

class RoomForm extends Component {
    constructor(props) {
        super(props);
        document.title = 'Room form';
    }

    url = {
        rooms: "/api/rooms/",
        hotelsInMap: "/api/hotels/inMap"
    };

    placeholder = {
        name: "Enter room name",
        numberOfBeds: "Enter the number of people that can sleep in the room",
        pricePerNight: "Enter the price per night",
        description: "Enter room description",
        imageUrl: "Enter an url for the room image"
    };

    state = {
        globalMessage: null,
        room: {
            id: null,
        },
        formData: {
            name: {
                value: "",
                isValid: true,
                message: null
            },
            numberOfBeds: {
                value: "",
                isValid: true,
                message: null
            },
            pricePerNight: {
                value: "",
                isValid: true,
                message: null
            },
            description: {
                value: "",
                isValid: true,
                message: null
            },
            imageUrl: {
                value: "",
                isValid: true,
                message: null
            },
            hotelId: {
                value: -1,
                isValid: true,
                message: null
            }
        },
        hotelsMap: [],
        files: []
    };

    componentDidMount() {

        this.setState({
            room: {
                id: null
            }
        });

        if (this.props.match.params.id !== undefined || this.props.match.params.id !== null) {
            axios.get(this.url.rooms + this.props.match.params.id)
                .then(response => {

                    const updateForm = {
                        ...this.state.formData
                    };

                    for (let propName in updateForm) {
                        updateForm[propName].value = response.data[propName];
                    }

                    this.setState({
                        formData: {
                            ...updateForm
                        },
                        room: {
                            id: this.props.match.params.id
                        }
                    })
                })
                .catch(error => {
                    console.log(error);
                })
        }
        axios.get(this.url.hotelsInMap)
            .then(response => {
                this.setState({
                    hotelsMap: response.data.hotelsMap
                })
            })
            .catch(error => {
                console.log(error);
            })
    }

    formSubmit = event => {
        event.preventDefault();

        let newImageUrl;

        if (this.state.files && this.state.files.length > 0) {
            // Fill file variable with the file content
            this.file = this.state.files[0];

            let body = new FormData();
            // Add file content to prepare the request
            body.append("file", this.file);

            axios.post("/api/rooms/image", body)
                .then(resp => {
                    newImageUrl = resp.data[0];
                    this.sendFormDatas(newImageUrl);
                })
        } else {
            this.sendFormDatas();
        }
    }

    sendFormDatas = (datas) => {

        let newPictureUrl = datas ? datas : this.state.formData.imageUrl.value;

        const data = {
            id: this.props.match.params.id,
            name: this.state.formData.name.value,
            description: this.state.formData.description.value,
            imageUrl: newPictureUrl,
            numberOfBeds: this.state.formData.numberOfBeds.value,
            pricePerNight: this.state.formData.pricePerNight.value,
            hotelId: this.state.formData.hotelId.value
        };

        if (data.id) {
            axios.put("/api/rooms", data)
                .then(() => {
                    this.props.history.push("/");
                })
                .catch(error => {
                    console.warn("error.response: ", error === null ? error.response : error);
                    this.validationHandler(error);
                });
        } else {
            axios.post("/api/rooms", data)
                .then(() => {
                    this.props.history.push("/");
                })
                .catch(error => {
                    console.warn("error.response: ", error === null ? error.response : error);
                    this.validationHandler(error);
                });
        }
    }
    validationHandler = error => {
        const responseData = error.response.data;
        const updatedFormData = {...this.state.formData};
        if (responseData !== null) {
            if (responseData.globalError) {
                this.setState({globalMessage: responseData.globalError});
            }
            if (responseData.fieldErrors) {
                for (let fe of responseData.fieldErrors) {
                    updatedFormData[fe.field] = {
                        value: this.state.formData[fe.field].value,
                        isValid: false,
                        message: fe.message
                    }
                }
            }
            this.setState({formData: updatedFormData});
        } else {
            this.setState({globalMessage: error});
        }
    }

    inputChangeHandler = event => {
        const value = event.target.value;
        const fieldName = event.target.name;
        const updatedFormData = {...this.state.formData};

        updatedFormData[fieldName] = {
            value: value,
            isValid: true,
            message: null
        }

        this.setState({formData: updatedFormData})
    }

    onPreviewDrop = (files) => {
        this.setState({
            files: this.state.files.concat(files),
        });
    }

    render() {

        const dropzoneStyle = {
            width: "100%",
            height: "150px",
            border: "3px dashed #d5d4d4",
            borderRadius: "7px",
            paddingBottom: '10px'
        };
        const dropzoneStyleActive = {
            background: "green",
        };
        const dropzoneStyleRejected = {
            background: "red",
        };

        const previewStyle = {
            width: '100%'
        };

        let imgUrl;
        if (this.state.formData.imageUrl.value !== null || this.state.formData.imageUrl.value.trim() !== '') {
            imgUrl = this.state.formData.imageUrl.value;
        }

        return (
            <Fragment>
                <h2>Edit room</h2>
                <hr/>
                {this.state.globalMessage ?
                    <div className="alert alert-warning">{this.state.globalMessage}</div> : ""}
                <div className="container">
                    <div className="card">
                        <div className="row">
                            <div className="card-body col-lg-3">
                                {this.state.formData.imageUrl.value &&
                                <Fragment>
                                    <img className="img-fluid" src={imgUrl} alt="Room"/>
                                    <br/>
                                    <br/>
                                </Fragment>
                                }
                                {this.state.files.length < 1 &&
                                <ReactDropzone
                                    accept="image/*"
                                    onDrop={this.onPreviewDrop}
                                    style={dropzoneStyle}
                                    activeStyle={dropzoneStyleActive}
                                    rejectStyle={dropzoneStyleRejected}
                                >
                                    Drop the new image here or click to open the file browser.
                                </ReactDropzone>
                                }
                                <Fragment>
                                    {this.state.files.map((file) => (
                                        <img
                                            alt="Preview"
                                            key={file.preview}
                                            src={file.preview}
                                            style={previewStyle}
                                        />
                                    ))}
                                </Fragment>
                            </div>
                            <div className="card-body col-lg-9">
                                <form onSubmit={this.formSubmit}>
                                    <InputComponent
                                        label="Room name:"
                                        type="text"
                                        object={this.state.formData.name}
                                        name="name"
                                        inputChangeHandler={this.inputChangeHandler}
                                        placeholder={this.placeholder.name}
                                    />
                                    <SelectComponent
                                        label="Hotel"
                                        name="hotelId"
                                        value={this.state.formData.hotelId.value}
                                        inputChangeHandler={this.inputChangeHandler}
                                        objectMap={this.state.hotelsMap}
                                    />
                                    <InputComponent
                                        label="Number of beds:"
                                        type="text"
                                        object={this.state.formData.numberOfBeds}
                                        name="numberOfBeds"
                                        inputChangeHandler={this.inputChangeHandler}
                                        placeholder={this.placeholder.numberOfBeds}
                                    />
                                    <InputComponent
                                        label="Price per night:"
                                        type="text"
                                        object={this.state.formData.pricePerNight}
                                        name="pricePerNight"
                                        placeholder={this.placeholder.pricePerNight}
                                        inputChangeHandler={this.inputChangeHandler}
                                    />
                                    <TextAreaComponent
                                        label="Description:"
                                        name="description"
                                        object={this.state.formData.description}
                                        placeholder={this.placeholder.description}
                                        inputChangeHandler={this.inputChangeHandler}
                                    />
                                    <button type="submit" className="btn btn-primary">Save room</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}

export default RoomForm;


// WEBPACK FOOTER //
// ./src/containers/EditRoomForm/EditRoomForm.jsx